import AntdModal from "antd/lib/modal";
import "antd/lib/modal/style/css";

export default AntdModal;
